module.exports = __webpack_public_path__ + "media/images/lb/801-a7ea02295fcbb2dd5d90ac9a8df7169e.svg";